/**
 * Context menu items.
 *
 * @module context.menu.items
 */

'use strict';


module.exports = {
    resetFilters: {
        items: [
            {
                className: 'theme-icon theme-icon-rc-f1'
            },
            gettext('Reset filters')
        ]
    },
    search: {
        items: [
            {
                className: 'theme-icon theme-icon-rc-f4'
            },
            gettext('Search')
        ]
    },
    createFolder: {
        items: [
            {
                className: 'theme-icon theme-icon-rc-f2'
            },
            gettext('Create folder')
        ]
    },
    deleteFile: {
        items: [
            {
                className: 'theme-icon theme-icon-rc-f1'
            },
            gettext('Delete')
        ]
    },
    pinShare: {
        items: [
            {
                className: 'theme-icon theme-icon-shortcut'
            },
            gettext('Create shortcut')
        ]
    },
    renamePinnedShare: {
        items: [
            {
                className: 'theme-icon theme-icon-rc-f4'
            },
            gettext('Rename')
        ]
    },
    unpinShare: {
        items: [
            {
                className: 'theme-icon theme-icon-rc-f1'
            },
            gettext('Delete')
        ]
    },
    setFavoritesState: {
        items: [
            {
                className: 'theme-icon theme-icon-rc-f3'
            },
            gettext('Favorites')
        ]
    },
    clearFavorites: {
        items: [
            {
                className: 'theme-icon theme-icon-rc-f1'
            },
            gettext('Clear')
        ]
    },
    clearSmbCache: {
        items: [
            {
                className: 'theme-icon theme-icon-rc-f1'
            },
            gettext('Clear cache')
        ]
    },
    clearNfsCache: {
        items: [
            {
                className: 'theme-icon theme-icon-rc-f1'
            },
            gettext('Clear cache')
        ]
    }
    /*,
        importPlaylist:     {
            items: [
                {
                    className: 'theme-icon theme-icon-shortcut'
                },
                gettext('Import playlist ')
            ]
            click: function () {
                var item = mainPanelList.$focusItem.value.item,
                    playlistData;

                if ( breadcrumbs.config.isDisplayPlaylist ) {
                    playlistData = playlist.items.map(function ( playlistItem ) {
                        return {
                            name: playlistItem.name,
                            uri:  playlistItem.uri
                        };
                    });

                    importPlaylist(playlistData, breadcrumbs.config.opened);
                    page.modals.actions.hide();
                } else {
                    fs.readFile(
                        item.path || breadcrumbs.path + item.name,
                        function ( error, result ) {
                            playlist = parser.parseM3u(result, breadcrumbs);

                            playlist.items = playlist.items.filter(function ( playlistItem ) {
                                var key;

                                for ( key in mediaTypes ) {
                                    if ( mediaTypes[key].extensions && mediaTypes[key].extensions.indexOf(playlistItem.extension || '') !== -1 ) {
                                        playlistItem.type = key.id;
                                        // if playlistItem has extension - it is a m3u-file; otherwise - m3u-stream
                                        playlistItem.subtype = playlistItem.extension ? FILE_SUBTYPE.playlistFile : FILE_SUBTYPE.playlistStream;

                                        return true;
                                    }
                                }

                                return false;
                            });

                            playlistData = playlist.items.map(function ( playlistItem ) {
                                return {
                                    name: playlistItem.name,
                                    uri:  playlistItem.uri
                                };
                            });
                            importPlaylist(playlistData, item.name);
                            page.modals.actions.hide();
                        }
                    );
                }
            }
        },
        import:     {
            items: [
                {
                    className: 'theme-icon theme-icon-shortcut'
                },
                gettext('Import')
            ]
            click: function () {
                var item = mainPanelList.$focusItem.value.item;

                importPlaylist([
                    {
                        name: item.name,
                        uri:  item.uri
                    }
                ], breadcrumbs.config.opened);
                page.modals.actions.hide();
            }
        }*/
};
